import React, { useState } from 'react';
import ArrowUp from '../../Constant/Icons/ArrowUp.svg';
import ArrowDown from '../../Constant/Icons/ArrowDown.svg';

const FAQComponent = ({ faqListItems }) => {
    let staticIndex = 1;
    const [expandedIndex, setExpandedIndex] = useState(null);

    const toggleFAQ = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    return (
        <ul className='faqList'>
            {faqListItems.map((item) => {
                const currentIndex = staticIndex;
                staticIndex++;

                return (
                    <li className={expandedIndex === currentIndex ? 'expanded' : ''} key={item.id}>
                        <div className="faqQPart" onClick={() => toggleFAQ(currentIndex)}>
                            <div className="faqIndex">{currentIndex}</div>
                            <div className="faqQuestion">
                                <strong>{item.question}</strong>
                            </div>
                            <div className="faqIcon">
                                <img
                                    src={expandedIndex === currentIndex ? ArrowUp : ArrowDown}
                                    width={30}
                                    height={30}
                                    alt="toggle"
                                />
                            </div>
                        </div>
                        {expandedIndex === currentIndex && (
                            <div className="faqAPart">
                                <p>{item.answer}</p>
                            </div>
                        )}
                    </li>
                );
            })}
        </ul>
    );
};

export default FAQComponent;
